/**
 * @flow
 * @relayHash 67e8e62403afc42e4235b9fbbfdb9f77
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getApprovalRequestsQueryVariables = {|
  orgId: string,
  type?: ?string,
  propertyId?: ?string,
|};
export type getApprovalRequestsQueryResponse = {|
  +approvalRequests: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +propertyId: string,
        +approvedAt: ?any,
        +approverEmails: string,
        +propertyName: string,
        +hyevent: ?{|
          +id: string,
          +title: string,
          +status: string,
          +propertyId: string,
          +publishAt: ?any,
        |},
        +createdAt: any,
      |}
    |}>
  |}
|};
export type getApprovalRequestsQuery = {|
  variables: getApprovalRequestsQueryVariables,
  response: getApprovalRequestsQueryResponse,
|};
*/


/*
query getApprovalRequestsQuery(
  $orgId: ID!
  $type: String
  $propertyId: ID
) {
  approvalRequests(orgId: $orgId, type: $type, propertyId: $propertyId) {
    edges {
      node {
        id
        propertyId
        approvedAt
        approverEmails
        propertyName
        hyevent {
          id
          title
          status
          propertyId
          publishAt
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "propertyId",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalRequests",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "ApprovalRequestConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ApprovalRequestEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ApprovalRequest",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approvedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approverEmails",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "hyevent",
                "storageKey": null,
                "args": null,
                "concreteType": "Hyevent",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "publishAt",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getApprovalRequestsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getApprovalRequestsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getApprovalRequestsQuery",
    "id": null,
    "text": "query getApprovalRequestsQuery(\n  $orgId: ID!\n  $type: String\n  $propertyId: ID\n) {\n  approvalRequests(orgId: $orgId, type: $type, propertyId: $propertyId) {\n    edges {\n      node {\n        id\n        propertyId\n        approvedAt\n        approverEmails\n        propertyName\n        hyevent {\n          id\n          title\n          status\n          propertyId\n          publishAt\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '883abb152d4ab9d0b910221ef36cbdd4';
module.exports = node;
